// 5 minutes
export const DEFAULT_CACHE_TIME = 300000

export const defaultQueryOptions = {
  staleTime: 0,
  cacheTime: 0,
  keepPreviousData: false,
  refetchOnWindowFocus: false,
  retry: false,
}

// For data that can be safely cached for long periods
export const longCacheQueryOptions = {
  ...defaultQueryOptions,
  staleTime: 60 * 60 * 1000, // 1 hour
  cacheTime: 24 * 60 * 60 * 1000, // 1 day
}
